import { render, staticRenderFns } from "./dates-section-date.vue?vue&type=template&id=3545d0db"
import script from "./dates-section-date.vue?vue&type=script&lang=js"
export * from "./dates-section-date.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports